import { UpdateJobState } from '../../store/state';
import { JobAction, JobsActions } from '../actions';

const initialState: UpdateJobState = {
  job: undefined,
  loading: false,
  saved: false,
  saving: false,
  error: '',
};

const updateJobReducer = (state: UpdateJobState = initialState, action: JobAction): UpdateJobState => {
  switch (action.type) {
    case JobsActions.CreateJob:
    case JobsActions.UpdateJob:
    case JobsActions.ReassignJob:
    case JobsActions.StartJob:
      return {
        ...state,
        job: undefined,
        saved: false,
        saving: true,
        error: '',
      };
    case JobsActions.CreateJobSuccess:
    case JobsActions.ReassignJobSuccess:
      return {
        ...state,
        job: action.payload,
        saved: true,
        saving: false,
        error: '',
      };
    case JobsActions.UpdateJobSuccess:
    case JobsActions.StartJobSuccess:
      return {
        ...state,
        job: undefined,
        saved: true,
        saving: false,
        error: '',
      };
    case JobsActions.CreateJobError:
    case JobsActions.UpdateJobError:
    case JobsActions.StartJobError:
    case JobsActions.ReassignJobError:
      return {
        ...state,
        job: undefined,
        saved: false,
        saving: false,
        error: action.payload,
      };
    case JobsActions.ResetUpdateJobState:
      return {
        job: undefined,
        saved: false,
        saving: false,
        error: '',
        loading: false,
      };
    default:
      return state;
  }
};

export default updateJobReducer;
